export default __webpack_public_path__ + "static/media/859.4d7ff040.gif";